/** @jsxImportSource react */
import { objectToURLQueryParams } from '@common/helpers/url';
import CtaButton from '@react/cta/CtaButton';
import withPostConversionModal from '@react/cta/hoc/withPostConversionModal';
import { func, object, string } from 'proptypes';
import React, { useMemo } from 'react';

const AssesmentWizardCta = ({
  ctaProps,
  startLink,
  mode,
  eventProps,
  startAssessmentFlow,
  buttonStyle = {},
  onClick,
  className,
}) => {
  const {
    variant = 'primary',
    palette = 'viridian',
    text: ctaButtonText,
  } = ctaProps;

  const navigationButtonProps = useMemo(() => {
    const sl = `${startLink}?${objectToURLQueryParams(mode)}`;
    return {
      to: sl,
      onClick: () => {
        startAssessmentFlow();
        onClick?.();
      },
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startLink, mode]);

  return (
    <>
      <CtaButton
        palette={palette}
        variant={variant}
        {...navigationButtonProps}
        eventProps={eventProps}
        className={className}
        {...buttonStyle}
      >
        {ctaButtonText || 'Get access'}
      </CtaButton>
    </>
  );
};

AssesmentWizardCta.propTypes = {
  ctaProps: object,
  startLink: string,
  mode: object,
  community: object,
  eventProps: object,
  startAssessmentFlow: func,
  buttonStyle: object,
  onClick: func,
};

export default withPostConversionModal(AssesmentWizardCta);
